<template>
  <div class="app-container">
    <span v-if="templateType" style="color: #5f6975;font-size: 14px;">{{  templateType  }} > {{ chargeItemCode }}</span>
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="true" :reset-btn-hide="true" :search-btn-hide="true" :before-reset-search="beforeResetSearch" @afterFetchOriginalData="updateTableData" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'startDate'">
                <span>{{ scope.row[col.prop] | timeChanges }}</span>
              </template>
              <template v-else-if="col.prop === 'endDate'">
                <span>{{ scope.row[col.prop] | timeChanges }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              <el-dropdown v-hasDropdownChildren size="mini" @command="command($event, props.row)">
                <span class="el-dropdown-link">
                  {{ $t('AccountManagement.common.operate') }} <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="1">{{ $t('editText') }}</el-dropdown-item>
                  <el-dropdown-item :command="2">{{ $t('delText') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @handleConfirm="handleConfirm" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { billApi } from '@/api';
import DataForm from './components/DataForm.vue';

export default {
  name: 'BusinessBillingHistoricaCost', 
  components: {DataForm},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      // 查询参数
      queryApi: billApi.getchargeItemHisList,
      queryParams: {
        template: this.$route.query.template || null,
        chargeItemCode: this.$route.query.chargeItemCode || null,
      },
      labelList: [
        { label: this.$t('billingPage.historicalBB'), prop: 'cost2b', isCheck: true, disabled: false },
        { label: this.$t('billingPage.hisGeneral'), prop: 'costPrice2b', isCheck: true, disabled: false },
        { label: this.$t('billingPage.hisTime'), prop: 'costMinute2b', isCheck: true, disabled: false },
        { label: this.$t('billingPage.position'), prop: 'position2bText', isCheck: true, disabled: false },
        { label: this.$t('billingPage.historicalCC'), prop: 'cost2c', isCheck: true, disabled: false },
        { label: this.$t('billingPage.hisGeneral'), prop: 'costPrice2c', isCheck: true, disabled: false },
        { label: this.$t('billingPage.hisTime'), prop: 'costMinute2c', isCheck: true, disabled: false },
        { label: this.$t('billingPage.position'), prop: 'position2cText', isCheck: true, disabled: false },
        { label: this.$t('billingPage.startDate'), prop: 'startDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.endDate'), prop: 'endDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Operator'), prop: 'operator', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 140 },
      ],
      templateType:null,
      chargeItemCode:null,
    };
  },
  methods: {
    // 获取tableData数据
    updateTableData(data) {
      this.templateType = data.content[0].templateType
      this.chargeItemCode = data.content[0].chargeItemCode
      data.content.forEach(item => {
        item.position2bText = ''
        item.position2cText = ''
        item.position2b.forEach(jitem=>{
          item.position2bText += ` ${jitem.name} : ${jitem.percentage} % ; `;
        })
        item.position2c.forEach(kitem=>{
          item.position2cText += ` ${kitem.name} : ${kitem.percentage} % ; `;
        })
      });
      return data;
    },
    // 查看
    onView(row) {
      billApi.detHistoricalList({costHistoryId:row.id}).then(e => {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.openType = 'view';
        this.$refs.DataForm.form = JSON.parse(JSON.stringify(e.data));
      });
    },
    command(val, item) {
      if (val === 1) { this.onEdit(item); }
      if (val === 2) { this.onDelete(item); }
    },
    // 编辑
    onEdit(row) {
      billApi.detHistoricalList({costHistoryId:row.id}).then(e => {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.openType = 'edit';
        this.$refs.DataForm.form.chargeItemCode = row.chargeItemCode;
        this.$refs.DataForm.form = JSON.parse(JSON.stringify(e.data));
      });
    },
    // 删除
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
      .then(() => {
        billApi.deleteHistoricalList({ costHistoryId: row.id }).then(res => {
          if (res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      });
    },
    // 子页面回调执行 '编辑' 方法
    handleConfirm(row) {
      billApi.updHistoricalList(row).then(() => {
        this.$refs.DataForm.handleClose();
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams = {
        template: this.$route.query.template || null,
        chargeItemCode: this.$route.query.chargeItemCode || null,
      };
      return new Promise(resolve => {
        resolve();
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
